<template>
  <div>
    <answer-render ref="answer" :config="config">
      <div class="area-wrapper" slot="body">
        <FormItem prop="value" :rules="rules">
          <div class="form-inner">
            <!-- pc端 -->
            <div v-if="windowType === 'pc'">
              <el-upload
                class="upload-container"
                drag
                ref="upload-file"
                :show-file-list="false"
                :http-request="uploadFileRequest"
                :accept="uploadFileTypeList"
                :file-list="fileList"
                :data="OSS"
                action="#"
                :before-upload="beforeUpload"
                :limit="config.answerConfig.maxUploadFileCount"
                :on-exceed="handleValidate"
                :disabled="uploadDisabled"
                @click.native="nativeUpload"
                multiple>
                <!-- <i class="el-icon-upload-file"></i> -->
                <svg-icon icon-class="no-data"></svg-icon>
                <div class="el-upload__text">
                  <em>{{cvtLang('tipsUploadFile', config.tipsUploadFile)}}</em>
                </div>
                <div class="el-upload__text" style="margin-top: 4px">{{uploadTips}}</div>
              </el-upload>
              <div class="upload-container">
                <ul class="el-upload-list el-upload-list--text">
                  <li class="el-upload-list__item is-success" v-for="file in config.value">
                    <a :href="file.url">
                      <el-image
                        v-if="isImg(file.type)"
                        style="width: 48px; height: 48px; vertical-align:middle"
                        :src="file.url"
                        fit="cover"
                        ></el-image>
                      <div v-else class="icon-container">
                        <svg-icon :icon-class="file.type | getFileIcon" />
                      </div>
                      <span class="file-name">{{file.name}}</span>
                    </a>
                    <i class="el-icon-close" @click="handleRemove(file)"></i>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 手机端 -->
            <div v-if="windowType === 'mobile'" class="mobile-area">
              <div class="mobile-tips">
                {{uploadTips}}
              </div>
              <div class="uploader-container">
                <div class="van-uploader__preview" style="" v-for="file in fileList">
                  <div class="van-uploader__file" style="width: 78px; height: 78px;">
                    <el-image
                      v-if="isImg(file.type)"
                      style="width: 78px; height: 78px; vertical-align:middle"
                      :src="file.content || file.url"
                      fit="cover"
                    ></el-image>
                    <svg-icon v-else :icon-class="file.type | getFileIcon" />
                    <div class="van-uploader__preview-cover">
                      <div class="preview-cover van-ellipsis">{{file.name}}</div>
                    </div>
                  </div>
                  <div class="van-uploader__mask" v-if="file.status">
                    <div class="van-loading van-loading--circular van-uploader__loading" v-if="file.status === 'uploading'">
                      <span class="van-loading__spinner van-loading__spinner--circular">
                        <svg viewBox="25 25 50 50" class="van-loading__circular"><circle cx="50" cy="50" r="20" fill="none"></circle></svg>
                      </span>
                    </div>
                    <div class="van-uploader__mask-message">{{file.message}}</div>
                  </div>
                  <div class="van-uploader__preview-delete" @click="handleMobileRemove(file)">
                    <i class="van-icon van-icon-cross van-uploader__preview-delete-icon"></i>
                  </div>
                </div>
                <van-uploader
                  multiple
                  preview-size="78"
                  v-model="fileList"
                  :preview-image="false"
                  :preview-full-image="false"
                  :max-count="this.config.answerConfig.maxUploadFileCount"
                  :max-size="this.config.answerConfig.maxUploadFileSize * 1024 * 1024"
                  :accept="isAppOnline ? '' : uploadFileTypeList"
                  :before-read="beforeUpload"
                  :after-read="afterRead"
                  :before-delete="handleRemove"
                  :disabled="uploadDisabled"
                  @oversize="handleValidate"
                  @touchstart.native="nativeUpload"
                >
                </van-uploader>
              </div>
            </div>
          </div>
        </FormItem>
      </div>
    </answer-render>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import answerValidate from './answerValidate'
import uploadFileClient from './uploadFile'
import cloneDeep from 'loadsh/cloneDeep'
import { getRandomString } from '@/utils'
import { Toast } from 'vant'

export default {
  name: 'UploadFileBoxAnswer',
  props: ['config'],
  data () {
    return {
      currentFile: null,
      fileList: [],
      tmpFileList: [],
      OSS: {
        policy: '',
        signature: '',
        key: '',
        ossAccessKeyId: '',
        dir: '',
        host: '',
        uid: '',
        surveyId: '',
        // callback:'',
      },
      rules: [
        {
          validator: (rule, value, callback) => {
            let errors = []
            if (this.loading) {
              return callback()
            }
            errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {},
  computed: {
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      lang: ({Question}) => Question.lang,
      langMap: ({Question}) => Question.langMap
    }),
    uploadTips() {
      const maxUploadFileCount = this.config.answerConfig.maxUploadFileCount
      const maxUploadFileSize = this.config.answerConfig.maxUploadFileSize
      if (this.isOrigin()) {
        return this.cvtLang('tipsMaxFilesCountError', this.config.tipsMaxFilesCountError).replace('${n}', maxUploadFileCount) + '，' + this.cvtLang('tipsMaxFilesCountError', this.config.tipsMaxFileSizeError).replace('${n}', maxUploadFileSize) + '。'
      } else {
        return this.cvtLang('tipsMaxFilesCountError', this.config.tipsMaxFilesCountError).replace('${n}', maxUploadFileCount) + ',' + this.cvtLang('tipsMaxFilesCountError', this.config.tipsMaxFileSizeError).replace('${n}', maxUploadFileSize) + '.'
      }
    },
    uploadFileTypeList() {
      return this.config.answerConfig.uploadFileTypeList + ',' + this.config.answerConfig.uploadFileTypeList.toUpperCase()
    },
    isAppOnline() {
      return window._execEnv_ === 'app' && window.navigator.onLine
    },
    uploadDisabled() {
      return !(this.isAppOnline ||  window._execEnv_ === 'h5')
    }
  },
  filters: {
    getFileIcon(type) {
        let res = 'file'
        switch (type.toLowerCase()) {
          case '.doc':
          case '.docx':
            res = 'file-word'
            break
          case '.xls':
          case '.xlsx':
            res = 'file-xls'
            break
          case '.ppt':
          case '.pptx':
            res = 'file-ppt'
            break
          case '.txt':
            res = 'file-txt'
            break
          case '.rar':
          case '.zip':
          case '.gzip':
            res = 'file-zip'
            break
          case '.pdf':
            res = 'file-pdf'
            break
          case '.mp4':
          case '.flv':
          case '.webm':
          case '.mov':
          case '.m4v':
          case '.wmv':
          case '.3gp':
            res = 'file-video'
            break
          case '.mp3':
          case '.wma':
          case '.wav':
          case '.amr':
          case '.m4a':
          case '.aac':
            res = 'file-radio'
            break
          case '.md':
            res = 'file-markdown'
            break
          case '.csv':
            res = 'file-csv'
            break
          default:
            res = 'file'
        }

        return res
    }
  },
  methods: {
    isImg(type) {
      return '.bmp, .png,.jpg,.jpeg,.gif'.includes(type)
    },
    beforeUpload(file) {
      if(file && file instanceof Array){
        file.forEach(item => {
          item.surveyId = this.config.belongId
        })

        this.currentFile = file
      }else{
        // 使用后台api上传时使用
        file.surveyId = this.config.belongId
        this.currentFile = [file]
      }
      return this.handleValidate()
    },
    handleRemove(file) {
      const findIndex = this.config.value.findIndex((item) => {
        return item.uid === file.uid
      })
      this.config.value.splice(findIndex, 1)
      return true
    },
    handleMobileRemove(file) {
      // 删除答题结果
      const findValueIndex = this.config.value.findIndex((item) => {
        return item.uid === file.uid
      })
      this.config.value.splice(findValueIndex, 1)

      // 删除列表数据
      const findListIndex = this.fileList.findIndex((item) => {
        return item.uid === file.uid
      })
      this.fileList.splice(findListIndex, 1)
      return true
    },
    handleValidate(files) {
      if (files) {
        if (this.windowType === 'pc') {
          files = Array.from(files)
        } else {
          // 只传一个文件
          if (!Array.isArray(files)) {
            files = [files]
          }

          files.forEach(item => {
            item.type = item.file.name && "." + item.file.name.split(".").pop()
            item.name = item.file.name
            item.surveyId = this.config.belongId
          })
        }

        this.currentFile = files
        this.tmpFileList = files
      }

      if (answerValidate) {
        const result = answerValidate.validate.bind(this.config)(this).result
        if (!result) {
          // 校验文件
          const validate = this.$refs.answer.$refs.answerValidate
          validate && validate.validate()
        }
        return result
      }
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    },
    // 离线调基座封装的原生上传接口
    nativeUpload() {
      if (window._env_ === 'android' && window._execEnv_ === 'app') {
        // android app离线环境下
        H5Expand.chooseFile().then(res=>{
          let { fileList: files } = res
          console.log('h5拿到了fileList: '+ JSON.stringify(files));

          /**
           * TODO
           * 1、需要确认离线和在线状态，在线走oss或服务器上传，离线走本地数据同步上传
           * 2、原生上传过来的files数据，是否有file对象，前端oss上传需要
           * 3、还是说后台上传后可以直接调oss返回上传的路径，前端不用单独处理了
           */

          const stashFiles = files.map(f=>{
            const { path, size } = f
            const fileName = path.split('/').pop()
            const fileExt = '.' + fileName.split('.').pop()
            return {
              file: {
                name: fileName,
                size
              },
              url: path,
              type: fileExt
            }
          })

          const result = this.handleValidate(stashFiles)
          if (result) {
            // console.log('校验成功')

            // 回调回来的file数组
            files = files.map(f=>{
              const { path, size } = f
              const fileName = path.split('/').pop()
              const fileExt = '.' + fileName.split('.').pop()
              return {
                uid: getRandomString(),
                name: fileName,
                url: path,
                type: fileExt,
              }
            })

            this.fileList = this.fileList.concat(files)
            files.forEach(file => {
              this.config.value.push({
                uid: file.uid,
                name: file.name,
                url: file.url,
                type: file.type
              })
            })

          }

        }).catch(e => {
            console.error('获取文件失败:' + e.message)
            // TODO 有些情况会出现获取文件失败, 需要给出提示
            Toast('文件获取失败，请重新选择!')
        })
      }
    },
    uploadFileRequest(e) {
      const result = this.handleValidate()
      if (!result) {
        this.$nextTick(() =>{
          this.$refs['upload-file'] && this.$refs['upload-file'].clearFiles()
          this.currentFile = null
        })
        return false
      }
      const that = this
      uploadFileClient.uploadFile(this.currentFile, this, function (file) {
        if (file.url) {
          that.$refs['upload-file'] && that.$refs['upload-file'].clearFiles()
          // 多文件上传时会多次调用
          that.currentFile = null
          that.config.value.push({
            uid: file.uid,
            name: file.name,
            url: file.url,
            type: file.name && "." + file.name.split(".").pop()
          })
        }
      })
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (!Array.isArray(file)) {
        file = [file]
      }

      file.forEach(item => {
        item.type = item.file.name && "." + item.file.name.split(".").pop()
        item.name = item.file.name
        item.surveyId = this.config.belongId
      })

      this.currentFile = file

      this.uploadFileRequest(this.currentFile)
    }
  },
  mounted () {
    this.fileList = cloneDeep(this.config.value)
  }
}
</script>
<style lang="scss" scoped>
  .dtl {
    margin-top: 18px;
  }
  .area-wrapper {
    min-height: 140px;
    .form-inner {
      margin-top: 30px;
      margin-bottom: 10px;
    }
    .area-box {
      display: flex;
    }
  }
  .answer-pc {
    .form-inner {
      margin-top: 10px;
    }

    .upload-container {
      width: 100%;

      .icon-container {
        position: relative;
        display: inline-block;
        width: 48px;
        height: 48px;
        vertical-align: middle;
        background: #F5F7FA;
        .svg-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 24px;
          height: 24px;
          transform: translate(-50%, -50%);
        }
      }

      >>> .el-upload {
        width: 100%;
      }

      >>> .el-upload-dragger {
        width: 100%;
        height: auto;
        padding: 16px 0;
        border: 1px solid #D5DBE6;
        border-radius: 2px;
        background-color: rgba(37, 40, 48, 0.03) !important;
      }

      >>> .el-upload__text{
        font-size: 16px;
        line-height: 24px;
      }
      .svg-icon {
        margin-bottom: 10px;
        font-size: 48px;
      }

      >>> .el-upload-list {
        .el-upload-list__item {
          height: 66px;
          padding: 9px;
          border: 1px solid #D5DBE6;
          border-radius: 2px;
          // padding: 9px 8px;

          a {
            color: #26BFAD;
            font-size: 0;

            .file-name {
              display: inline-block;
              margin-left: 8px;
              font-size: 14px;
              vertical-align: middle;
            }
          }

          .el-upload-list__item-status-label {
            right: 9px;
          }

          .el-icon-close {
            top: 50%;
            right: 9px;
            transform: translate(0, -50%);
          }

          .el-icon-close-tip {
            display: none;
          }
        }
      }
    }
  }

  .mobile-tips {
    margin-bottom: 16px;
    font-size: 28px;
    line-height: 40px;
    color: rgba(0, 0, 0, 0.45);
  }

  .mobile-area {
    .uploader-container {
      display: flex;
      flex-wrap: wrap;
    }

    .svg-icon {
      width: 72px;
      height: 72px;
      vertical-align: middle;
    }

    >>> .van-uploader__file {
      color: #26BFAD;
    }

    .preview-cover {
      position: absolute;
      bottom: 0;
      box-sizing: border-box;
      width: 100%;
      padding: 4px;
      color: #fff;
      font-size: 24px;
      text-align: center;
      background: rgba(0, 0, 0, 0.3);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/UploadFileBox/UploadFileBoxAnswer.vue